<template>
  <modal :show="show" @change="$emit('change', $event)" :headerClass="currentLocale === 'ru' ? 'bg-main-orange white--text helvetica-roman fs-18' : 'bg-main-orange white--text rubik-medium fs-18'" width="600">
    <template v-slot:header>
      <span>{{$t('modals.modalPaymentNew.client')}}</span>
    </template>
    <template v-slot:main>
      <div v-if="!paySuccess" class="modal-info text-center mx-7">
        <span class="d-block my-5 fs-16">
          <strong>
            {{$t('modals.modalPaymentNew.info')}}
          </strong>
        </span>
        <!--  <div v-if="energyPay" class="text-left commission ml-2 fs-15">
      <span><strong>Комиссия банка:</strong> </span>
      <v-row class="fs-15" col="2">
        <v-col
          ><strong
            >По услуге электроснабжение <br> АО «Татэнергосбыт»:</strong
          ></v-col
        >
        <v-col><br /><strong>0 % </strong> по карте любого банка</v-col>
      </v-row>
      <v-row class="fs-15" col="2">
        <v-col><strong>По остальным услугам:</strong></v-col>
        <v-col
          ><strong>0 % </strong>по карте Ак Барс Банка<br /><strong
            >0,8 % </strong
          >по картам других банков</v-col
        >
      </v-row>
    </div>
    <div v-else class="text-left commission ml-10 pl-10">
      <span class="fs-14"
        ><strong>Комиссия банка:</strong> <br /><strong>0</strong> % - по картам
        ПАО «АК БАРС» Банк <br /><strong>0,8</strong> % - по картам других
        банков
      </span>
    </div> -->

        <div class="mt-3">
          <v-btn @click="GetBankUrl()"
                 class="orange-button mb-5"
                 :class="{'buttonFont': currentLocale === 'tat'}"
                 :loading="loading">
            {{$t('buttons.pay')}}
          </v-btn>
        </div>


        <div class="table-pay">
          <div class="vtb-button-cont">
            <span class="smaller-blue-text" style="color: dimgrey;">
              {{$t('modals.modalPaymentNew.vtbInfoPart1')}}  <br> {{$t('modals.modalPaymentNew.vtbInfoPart2')}} <br>{{$t('modals.modalPaymentNew.vtbInfoPart3')}}
            </span>
            <div class="mt-3">
              <v-btn class="mb-5 vtb-button v-btn v-btn--contained theme--light v-size--default"
                     @click="GetVTBUrl()">
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <circle cx="12" cy="12" r="11" fill="white" />
                  <g transform="translate(12, 12) scale(0.85) translate(-12, -12)">
                    <g transform="translate(3.2, -1.2)">
                      <path fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16.785 10.8h-13.8L3.981 8h13.8l-.996 2.8Zm-.498 1.4h-13.8L1.49 15h13.8l.996-2.8Zm-1.491 4.2H.995L0 19.2h13.8l.995-2.8Z"
                            fill="#0663ef" />
                    </g>
                  </g>
                </svg>
                <span>Pay</span>
              </v-btn>
            </div>

          </div>
            <div class="left-con-table-pay">
              <span class="smaller-blue-text" style="color:dimgrey;">
                {{$t('modals.modalPaymentNew.serviceInfoPart1')}}<br>{{$t('modals.modalPaymentNew.serviceInfoPart2')}}
              </span>
              <div class="mt-3">
                <v-btn class="mb-5 green-button-pay" :class="{'buttonFont': currentLocale === 'tat'}"
                       href="https://tatenergosbyt.ru/communal/how-pay/#banki">
                  {{$t('modals.modalPaymentNew.go')}}
                </v-btn>
              </div>
            </div>
        </div>
      </div>
      <div v-if="paySuccess" class="modal-info text-center mx-7 mt-10">
        <span class="d-block my-5 fs-18">
          {{$t('modals.modalPaymentNew.serviceNotAvailable')}}
        </span>
        <v-btn
          @click="$emit('change', false)"
          class="orange-button mb-1 mt-5"
          :loading="loading"
          >{{$t('buttons.close')}}
        </v-btn>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mask } from "vue-the-mask";
import { mapGetters, mapState } from "vuex";
import { AxiosWrapper } from "@/assets/api/AxiosWrapper";

export default {
  name: "ModalPayment",
  directives: {
    mask,
  },
  components: {
    Modal,
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    toPay: {
      required: true,
      type: [Number, String],
      default: 0,
    },
    energyPay: {
      type: Boolean,
      default: false,
    },
    details: {
      required: false,
      type: Array,
    },
  },
  data: () => ({
    message: "",
    email: "",
    phone: "",
    sendTo: {
      email: false,
      phone: false,
    },
    paySuccess: false,
    loading: false,
    valid: false,
    phoneRules: [
      (v) => !!v || "Номер телефона",
      (v) =>
        /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/.test(v) || "Введите корректный номер",
    ],
    emailRules: [
      (v) => !!v || "Введите e-mail",
      (v) =>
        /^[^'"\|`~{}\[\]\/()\\=,<>\s\t]+$/.test(v) ||
        "Введены недопустимые символы",
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) ||
        "Введите корректный e-mail",
    ],
  }),
  computed: {
    ...mapState("account", ["selectedAccount"]),
    ...mapGetters("account", ["userSettings"]),
    ...mapGetters("locale",["currentLocale"]),
    disabled() {
      if (this.sendTo.email) {
        return !!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(this.email);
      } else if (this.sendTo.phone) {
        return !!/^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/.test(this.phone);
      } else {
        return false;
      }
    },
  },
  methods: {
    async GetVTBUrl(testMode = false) {
      try {
        const url = 'https://online.vtb.ru/i/pay/id/fc0cd01a-86e6-48a7-9a5a-5e9934187542?PHONE=' + this.selectedAccount.domHoz;
        window.open(url, '_blank');

      } catch (error) {
        console.error('Ошибка:', error);
      } finally {
        this.loading = false;
      }
    },
    GetBankUrl(testMode = false) {
      this.loading = true;
      let postData = {
        appVersion: "LKFL",
        personalAccount: this.selectedAccount.domHoz,
        idAccount: this.selectedAccount.isOwner === undefined || this.selectedAccount.isOwner 
          ? this.userSettings.userGuid : this.selectedAccount.guid,
        paySum: this.toPay,
      };

      AxiosWrapper.postForGetBankUrl("GetBankUrl", postData)
        .then((response) => {
          if (response.data.success) {
            // console.log(response.data)
            // return;
            window.open(response.data.url, "_top");
          } else {
            this.paySuccess = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validate() {},
    telEncode(tel) {
      const encodedTel = "+" + tel.replace(/\D+/g, "");
      return encodedTel;
    },
  },
  created() {},
  watch: {},
  mounted() {},
};
</script>

<style lang="scss">
  .green-button-pay {
    background: linear-gradient(rgb(57, 181, 74), rgb(0, 146, 69));
    color: white !important;
    font-family: HelveticaNeueCyr !important;
    font-weight: 500;
    text-transform: none !important;
    font-size: 16px !important;
    opacity: 0.7;
  }
  .left-con-table-pay {
  }
  .table-pay {
    display: flex;
  }
  .vtb-button-cont {
    flex: 0 0 50%;
    border-right: 1px solid rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .vtb-button {
    justify-content: center;
    margin: 0 auto;
    text-align: center;
    align-items: center;
    padding: 10px;
    display: flex;
    height: auto;
    //background-color: #0663ef;
    background: linear-gradient(rgb(0, 113, 188), rgb(0, 0, 255));
    color: white !important;
    font-family: HelveticaNeueCyr !important;
    text-transform: none !important;
    font-size: 16px !important;
    color: white;
    width: 101.359px;
    opacity: 0.7;
  }
  @media (max-width: 768px) {
    .vtb-button {
      width: 100%;
      height: auto;
    }
  }

  .smaller-blue-text {
    display: block;
    margin-top: 1rem;
    margin-left: 1rem;
    margin-right: 1rem;
    text-align: center;
    color: blue;
    font-size: 0.8em;
    font-weight: bold;
  }
.modal-info {
  min-height: 200px;
  //display: flex;
  //flex-direction: column;

  &__message {
    margin: auto;
  }
}

.orange--checkbox {
  color: green !important;

  .accent--text {
    i {
      color: green !important;
    }
  }

  .v-application .accent--text {
    color: green !important;
  }
}

.modalPayment__form-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 100%;

  .modalPayment__form-checkbox {
    position: relative;
    height: max-content;
    padding: 5px 0 0 0;
  }

  .modalPayment__form-field {
    position: relative;
    width: calc(100% - 32px);
    height: max-content;
  }

  .commission {
    margin-left: 2110px;
    padding-left: 1000px;
  }
}
  .buttonFont{
    font-family: Rubik-Medium !important;
  }
</style>
